import { FC } from "react";
import TableColumn, { TColumnData } from "./table_column";
import NodataAvailable from "../../assets/images/NodataAvailable.svg";
import TableRow from "./table_row";

const Table: FC<{
    columns: TColumnData[],
    data: React.ReactElement[][],
    maxHeight: string;
    onRowClick?: (index: number) => void;
}>
    = ({
        columns,
        data,
        maxHeight,
        onRowClick,
    }) => {

        return (
            <div
                className="rounded-lg overflow-hidden w-full"
                style={{
                    maxHeight: maxHeight,
                    overflow: "hidden",
                    transition: "max-height 0.3s ease",
                }}
            >
                <div
                    className="flex flex-col w-full border border-gray-300 rounded-lg overflow-hidden"
                    style={{
                        maxHeight: maxHeight,
                        transition: "max-height 0.3s ease",
                    }}
                >
                    <div
                        className="overflow-y-auto"
                        style={{
                            maxHeight: "100%",
                        }}
                        id="scroll_style"
                    >
                        <div
                            className="flex border-b border-gray-300 sticky top-0 z-10"
                            style={{ background: "#EBFFF0" }}
                        >
                            {
                                columns.map((col) => <TableColumn text={col.text} width={col.width} classes={col.classes} />)
                            }
                        </div>
                        <div
                            className="bg-white overflow-x-auto"
                            id="scroll_style"
                        >
                            {
                                data.length > 0 ? (
                                    <>
                                        {data.map((row, i) => (
                                            <div
                                                key={i}
                                                className="flex border-b border-gray-300 cursor-pointer"
                                                onClick={() => {
                                                    if (onRowClick != null) {
                                                        onRowClick(i);
                                                    }
                                                }}
                                            >
                                                {
                                                    row.map((item, j) =>
                                                        <TableRow
                                                            child={item}
                                                            width={columns[j].width}
                                                        />
                                                    )
                                                }
                                            </div>
                                        ))}
                                    </>
                                ) : (
                                    <div className="flex justify-center items-center h-full w-full bg-white py-4">
                                        <img src={NodataAvailable} alt="No Data" />
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div >
        );
    }

export default Table;